"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _LifecycleState = _interopRequireDefault(require("../../LifecycleState"));
var styles = {
  "patch-version-properties": "PatchVersionProperties__patch-version-properties__1jynX",
  "patchVersionProperties": "PatchVersionProperties__patch-version-properties__1jynX",
  "latest-version": "PatchVersionProperties__latest-version__M7tGh",
  "latestVersion": "PatchVersionProperties__latest-version__M7tGh",
  "metadata": "PatchVersionProperties__metadata__1nydH"
}; 
require('./PatchVersionProperties.css');
var PatchVersionProperties = function PatchVersionProperties(_ref) {
  var asset = _ref.asset;
  var isPublicPortal = (0, _exchangeReactHooks.useIsPublicPortal)();
  var portalMetadata = (0, _exchangeReactHooks.usePortalMetadata)(isPublicPortal ? 'public-portal' : 'portal');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.patchVersionProperties,
    "data-test-id": "patch-version-properties"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Latest"), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.latestVersion
  }, asset.version), /*#__PURE__*/_react.default.createElement(_LifecycleState.default, {
    asset: asset
  }), portalMetadata.map(function (metadata, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.metadata,
      title: metadata.label,
      key: "patch-version-metadata-".concat(metadata.label),
      "data-test-id": "patch-version-metadata-".concat(index)
    }, metadata.render(asset));
  }));
};
var _default = exports.default = PatchVersionProperties;
//# sourceMappingURL=PatchVersionProperties.js.map